import { Model } from 'modules/core/lib/mobx-rest'

import { IPayrollLegalEntityResource } from '../collections/payrollLegalEntityResource'

class SpainA3innuvaJobPosition extends Model<IPayrollLegalEntityResource> {
  static urlRoot() {
    return '/contracts/spain/a3innuva_job_positions'
  }
}

export default SpainA3innuvaJobPosition
